import React, { useState } from "react";

import { useParams } from "react-router";

import { CustomTable } from "src/app/components/CustomTable/CustomTable";
import {
  nameColumnWidth,
  actionColumnWidth,
} from "src/app/components/GlobalTaskDetails/tabs/GlobalActivityTab/utils";
import goToImage from "src/images/share-alt.svg";
import { Img } from "src/app/components/Img/Img";
import { AvatarAndName } from "src/app/components/GlobalTaskDetails/tabs/GlobalActivityTab/GlobalActivityTabCampaigns";
import { TaskType } from "src/types";
import { ProjectPermissionsEnum } from "src/utils/PermissionsEnums";
import { EmptyActivityTab } from "src/app/Task/tabs/ActivityTab/EmptyActivityTab";
import AssociateTaskModal from "src/app/modals/AssociateTaskModal/AssociateTaskModal";
import circleTick from "src/images/circle-tick-1.svg";
import { Button } from "src/app/components/Button/Button";
import { ReactComponent as PlusWhiteIcon } from "src/images/plus-white.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { handleRowClick } from "../../utils/methods";
import { EmptyActionsTab } from "../ProfileDataTab/components/EmptyTabs/EmptyActionsTab";
import { Task } from "../ActivityTab/ActivityTab";

interface ActionsTabProps {
  tasks: Task[];
  taskType: TaskType;
  permissions: { project: string[] };
}

export const actionsColumnSettings = [
  {
    Header: "NAME",
    accessor: "name",
    width: nameColumnWidth,
  },
  {
    Header: "ACTION",
    accessor: "action",
    width: actionColumnWidth,
  },
];

export function ActionsTab({ tasks, taskType, permissions }: ActionsTabProps) {
  const params = useParams<{ projectId: string; workspaceUuid: string }>();
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);

  const generateRows = (tasks: Task[]) => {
    return tasks.map((task) => {
      return {
        name: (
          <AvatarAndName
            name={task.title}
            placeholder={circleTick}
            avatarWidth={24}
            avatarHeight={24}
          />
        ),
        action: <Img src={goToImage} fallbackImageSrc={goToImage} />,
        onRowClick: () =>
          handleRowClick(
            task.id,
            TaskType.Action,
            params.workspaceUuid,
            params.projectId,
          ),
      };
    });
  };

  return (
    <div className="activity-tab__table-wrapper">
      <CustomTable
        columns={actionsColumnSettings}
        data={generateRows(tasks)}
        headerClassName="activity-tab__table-header"
        noRowsPlaceholder={
          permissions?.project.includes(
            ProjectPermissionsEnum.TASK_MANAGEMENT,
          ) ? (
            <EmptyActionsTab
              taskType={taskType}
              onButtonClick={() => setShowAddTaskModal(true)}
            />
          ) : (
            <EmptyActivityTab />
          )
        }
      />

      {tasks.length > 0 &&
        permissions?.project.includes(
          ProjectPermissionsEnum.TASK_MANAGEMENT,
        ) && (
          <Button
            className="activity-tab__add-button"
            size="thin"
            variant="blue"
            onClick={() => setShowAddTaskModal(true)}
          >
            <PlusWhiteIcon />
            <IDHFormattedMessage
              id="ws_add_action"
              defaultMessage="Add action"
            />
          </Button>
        )}

      {showAddTaskModal && (
        <AssociateTaskModal
          projectId={params.projectId}
          onClose={() => setShowAddTaskModal(false)}
          taskType={TaskType.Action}
          tasksList={tasks}
          lastTaskRank={tasks.length ? tasks[tasks.length - 1].rank : ""}
        />
      )}
    </div>
  );
}
